import { render, staticRenderFns } from "./TurnoversTabContent.vue?vue&type=template&id=659f407e&scoped=true&"
import script from "./TurnoversTabContent.vue?vue&type=script&lang=ts&"
export * from "./TurnoversTabContent.vue?vue&type=script&lang=ts&"
import style0 from "./TurnoversTabContent.vue?vue&type=style&index=0&id=659f407e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659f407e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
